export default "__VITE_PUBLIC_ASSET__7f91ffc3__"